'use client';

import { Pill } from "@/ui/controls/buttons";
import { FlexCol, FlexRow } from "@/ui/controls/layout";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { SERVICES } from "@/fe/services";
import { CLM } from "@/common/schema/claims";

export function TopLeftHud({ rawClaim }: {
  rawClaim?: CLM.RawClaim,
}) {
  const { PD } = SERVICES();

  // TODO: Find some place to store keys, maybe they're an enum?  Maybe there should be a pin service that hides the keys?
  const [pinned, setPinned] = useState(() => {
    return PD.get('top-left-hud-pinned');
  });

  useEffect(() => {
    PD.set('top-left-hud-pinned', pinned);
  }, [PD, pinned]);

  return <>
    {<div className={clsx(
      "fixed z-50 left-2 top-28 bg-blue-200/25 w-400 overflow-auto",
      pinned ? "opacity-100" : "opacity-0 hover:opacity-100"
      )}>
      <FlexRow>
        {<Pill onClick={() => setPinned(!pinned)}>{pinned ? 'Unpin' : 'Pin'}</Pill>}
        <FlexCol>
          <div className="pt-2 pr-2">
            {rawClaim && "Test Claim Number: " + (rawClaim.testClaimNumber ?? "--")}
          </div>
        </FlexCol>
      </FlexRow>
    </div>}
  </>;
}
